import { ref, getBlob, getDownloadURL } from 'firebase/storage';
import { storage } from '../firebase';

/**
 * Trigger a browser Save-As download for a file.
 * Uses blob + anchor approach so the browser saves to disk
 * instead of opening images/PDFs in a new tab.
 *
 * @param {string} url       - Download URL (Firebase Storage or other)
 * @param {string} filename  - Suggested save filename
 * @param {string} storagePath - Firebase Storage path (preferred, avoids CORS)
 */
export const downloadFile = async (url, filename, storagePath) => {
  try {
    let blob;

    if (storagePath) {
      blob = await getBlob(ref(storage, storagePath));
    } else if (url) {
      // Try fetching via SDK getDownloadURL to get a fresh token URL
      // Fall back to direct fetch if no storagePath
      const response = await fetch(url);
      if (!response.ok) throw new Error(`Fetch failed: ${response.status}`);
      blob = await response.blob();
    } else {
      throw new Error('No URL or storage path available');
    }

    const blobUrl = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = blobUrl;
    a.download = filename || 'download';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    // Revoke after short delay to allow download to start
    setTimeout(() => URL.revokeObjectURL(blobUrl), 1000);
  } catch {
    // Fallback: open in new tab (browser handles it)
    if (url) window.open(url, '_blank');
  }
};

/**
 * Get a fresh download URL for a Firebase Storage path.
 */
export const getFreshDownloadUrl = async (storagePath) => {
  return getDownloadURL(ref(storage, storagePath));
};
